<mat-toolbar class="mat-elevation-z8">
  Parkeringsplats:
  @if (orderParkingVM && orderParkingVM.parkingSiteName) {
  <span> {{orderParkingVM.parkingSiteName}} </span>
  }
  <div class="spacer"></div>
  Status:
  @if (orderParkingVM && orderParkingVM.status) {
  <span> {{orderParkingVM.status}} </span>
  }
</mat-toolbar>

@if (isLoading) {
<div class="spinner">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
}

<mat-dialog-content class="mt-3">
  @if (orderParkingVM && (
  myConfigService.hasOrganizationIdRole(orderParkingVM.organizationId, 'ParkingOperator',
  orderParkingVM.organizationParentId) ||
  myConfigService.hasOrganizationIdRole(orderParkingVM.organizationId, 'ParkingAdministrator',
  orderParkingVM.organizationParentId) ||
  myConfigService.hasOrganizationIdRole(orderParkingVM.organizationId, 'ParkingSurveillance',
  orderParkingVM.organizationParentId) ||
  myConfigService.hasOrganizationIdRole(orderParkingVM.organizationId, 'ShuttleDriver',
  orderParkingVM.organizationParentId) )) {
  <div class="mb-4">
    @if (!data.isSubscription) {
    <button mat-stroked-button class="mr-2" color="primary" (click)="setNoShow()">Status NoShow</button>
    }
    <button mat-stroked-button class="mr-2" color="primary" (click)="setPaid()">Status Paid</button>
    @if (orderParkingVM.status === 'Checkin' || orderParkingVM.status === 'Checkout') {
    <button mat-stroked-button class="mr-2" color="primary" (click)="resetCheckIn()">Återställ incheckning</button>
    }
    @if (orderParkingVM.status === 'Checkout') {
    <button mat-stroked-button class="mr-2" color="primary" (click)="resetCheckOut()">Återställ utcheckning</button>
    }
  </div>
  }


  <div class="my-2">
    <form [formGroup]="editOrderParkingForm">
      <table>
        <tr>
          <td colspan="2">
            <mat-form-field appearance="outline">
              <mat-label>Registreringsnummer</mat-label>
              <input matInput formControlName="carId" placeholder="Registreringsnummer" (input)="sanitizeInput($event)">
            </mat-form-field>
          </td>
        </tr>
        <tr>
          <td class="date-cell">
            <mat-form-field appearance="outline">
              <mat-label>Parkering från</mat-label>
              <input matInput formControlName="parkingFrom" [matDatepicker]="parkingFrom">
              <mat-datepicker-toggle matSuffix [for]="parkingFrom"></mat-datepicker-toggle>
              <mat-datepicker #parkingFrom></mat-datepicker>
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="outline">
              <mat-label>Parkering från tid</mat-label>
              <input matInput type="time" value="{{parkingFromTime}}" formControlName="parkingFromTime">
              <mat-icon matSuffix>schedule</mat-icon>
            </mat-form-field>
          </td>
        </tr>
        <tr>
          <td>
            <mat-form-field appearance="outline">
              <mat-label>Parkering till</mat-label>
              <input matInput formControlName="parkingTo" formControlName="parkingTo" [matDatepicker]="parkingTo">
              <mat-datepicker-toggle matSuffix [for]="parkingTo"></mat-datepicker-toggle>
              <mat-datepicker #parkingTo></mat-datepicker>
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="outline">
              <mat-label>Parkering till tid</mat-label>
              <input matInput type="time" value="{{parkingToTime}}" formControlName="parkingToTime">
              <mat-icon matSuffix>schedule</mat-icon>
            </mat-form-field>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <mat-form-field appearance="outline">
              <mat-label>Parkeringsplats</mat-label>
              <mat-select formControlName="parkingSiteId">
                @for (spot of availableParkingSpots; track spot) {
                <mat-option [value]="spot.parkingSiteId">
                  <span>
                    Parkeringsplats: {{ spot.parkingSiteName }}
                  </span>
                </mat-option>
                }
              </mat-select>
              <mat-icon matSuffix>local_parking</mat-icon>
            </mat-form-field>
          </td>
        </tr>
        <tr>
          <td class="date-cell">
            <mat-form-field appearance="outline">
              <mat-label>Checkin</mat-label>
              <input matInput formControlName="checkIn" [matDatepicker]="checkIn">
              <mat-datepicker-toggle matSuffix [for]="checkIn"></mat-datepicker-toggle>
              <mat-datepicker #checkIn></mat-datepicker>
            </mat-form-field>
          </td>
          <td class="checkin-row">
            <mat-form-field appearance="outline" class="time-field" subscriptSizing="dynamic">
              <mat-label>Checkin tid</mat-label>
              <input matInput type="time" value="{{checkInTime}}" formControlName="checkInTime">
              <mat-icon matSuffix>schedule</mat-icon>
            </mat-form-field>
            <button mat-mini-fab color="primary" (click)="checkInParking()" class="button-align">
              <mat-icon>arrow_back</mat-icon>
            </button>
          </td>
        </tr>
        <tr>
          <td class="date-cell">
            <mat-form-field appearance="outline">
              <mat-label>Checkout</mat-label>
              <input matInput formControlName="checkOut" [matDatepicker]="checkOut">
              <mat-datepicker-toggle matSuffix [for]="checkOut"></mat-datepicker-toggle>
              <mat-datepicker #checkOut></mat-datepicker>
            </mat-form-field>
          </td>
          <td class="checkin-row">
            <mat-form-field appearance="outline" class="time-field" subscriptSizing="dynamic">
              <mat-label>Checkout tid</mat-label>
              <input matInput type="time" value="{{checkOutTime}}" formControlName="checkOutTime">
              <mat-icon matSuffix>schedule</mat-icon>
            </mat-form-field>
            <button mat-mini-fab color="primary" (click)="checkOutParking()" class="button-align">
              <mat-icon>arrow_forward</mat-icon>
            </button>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <mat-form-field appearance="outline">
              <mat-label>Kommentar</mat-label>
              <textarea formControlName="comment" matInput rows="2"></textarea>
            </mat-form-field>
          </td>
        </tr>
      </table>
    </form>
  </div>

</mat-dialog-content>

<mat-dialog-actions class="my-3 mx-4" align="end">
  <button mat-raised-button color="primary" [disabled]="isDisabled" (click)="saveChanges()">SPARA</button>
  <button mat-button mat-dialog-close>STÄNG</button>
</mat-dialog-actions>